export default __webpack_public_path__ + "static/media/1.b85c142a.png";